import { render } from "./Instrument.vue?vue&type=template&id=0a4e7caf&scoped=true"
import script from "./Instrument.vue?vue&type=script&lang=js"
export * from "./Instrument.vue?vue&type=script&lang=js"

import "./Instrument.vue?vue&type=style&index=0&id=0a4e7caf&scoped=true&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\四个火体育_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a4e7caf"]])

export default __exports__